/**
 * Utility to strictly ensure zero numeric prices or currency symbols exist in SEO meta, content, or hubs.
 */

export function stripNumericPrices(text: string): string {
  if (!text) return text;
  return text
    // Replace "from ₹46.5L" or "from ₹ 46.5 L" or "starting from ₹46.5L"
    .replace(/(?:starting\s+)?(?:from\s+)?₹\s*[\d,.]+\s*(?:L|Cr|Lakhs?|Crores?|k|K)?\.?/gi, '')
    // Replace remaining standalone ₹ amounts e.g. "₹46.5L"
    .replace(/₹\s*[\d,.]+\s*(?:L|Cr|Lakhs?|Crores?|k|K)?\.?/gi, '')
    // Clean double spaces or trailing periods
    .replace(/\s{2,}/g, ' ')
    .replace(/\s+\./g, '.')
    .trim();
}
